import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { FormCoverages } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepThreeFormContext } from '../../../../../StepThree/contexts/StepThreeForm';

export const PropertyDataSection = () => {
  const { civilQuotationComponents } = useContext(StepThreeFormContext);

  const [activeTab, setActiveTab] = useState<any>(
    civilQuotationComponents[0]?.nroComponente
  );
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = civilQuotationComponents.map(
      (civilComponent, index: number) => ({
        children: <FormCoverages civilComponent={civilComponent} />,
        closable: false,
        forceRender: true,
        key: civilComponent.nroComponente,
        label: `Resp. Civil ${civilComponent.nroComponente}`,
      })
    );

    setTabs(newTabs);
  }, [civilQuotationComponents, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='p-15'>
      <ColSize size={100}>
        <Tabs
          activeKey={activeTab}
          handlePressTab={handlePressTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
